export default __webpack_public_path__ + "static/media/main-logo.29d0369f.png";